import {styled} from '@mui/material/styles'
import {Box, Button, Chip} from '@mui/material'

export const CategoryHeaderContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingBottom: '4px'
})

export const CategoryTitleWrapper = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
  flex: 1
}))

export const CategoryTitle = styled(Box)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  fontSize: theme.typography.body1.fontSize,
  fontWeight: theme.typography.fontWeightBold,
  color: theme.palette.text.primary
}))

export const StyledCategoryCountChip = styled(Chip)(({theme}) => ({
  height: 20,
  '& .MuiChip-label': {
    fontSize: theme.typography.body2.fontSize,
    padding: `0 ${theme.spacing(0.75)}`
  }
}))

export const StyledCategoryAddButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'isOpen'
})(({theme, isOpen}) => ({
  textTransform: 'none',
  color: theme.palette.primary.main,
  fontWeight: theme.typography.fontWeightSemibold,
  fontSize: theme.typography.subtitle1.fontSize,
  minWidth: 'auto',
  backgroundColor: isOpen ? theme.palette.hpPrimaryLightest : 'transparent',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    border: 'none'
  }
}))
